let counter = 0;

const IDS = {};

const CACHE = {};

/** Basically fetch(), but JSONp.
 *	Note: for simplicity, this skips the `Response` interface entirely, returning instead the result data.
 *	@param {String} url
 *	@param {Object} [options]
 *	@param {Number} [options.timeout=30]					Seconds after which to terminate the request and reject the promise
 *	@param {Number} [options.callbackName=servicejsonp\d]	Manually specify the callback name
 *	@param {Number} [options.callbackParam=callback]		Change the callback querystring parameter
 */
export default function fetchJsonp(url, options={}) {
	if (options.cache!==false && options.dedupe!==false && CACHE.hasOwnProperty(url)) return CACHE[url];

	return CACHE[url] = new Promise( (resolve, reject) => {
		let callback = options.callbackName || `servicejsonp${options.callbackId || ++counter}`,
			callbackRootName = callback,
			c = 0;
		// ensure in-flight callback name uniqueness using an increment suffix
		while (IDS.hasOwnProperty(callback)) callback = `${callbackRootName}_${++c}`;
		IDS[callback] = true;
		let done = window[callback] = (data) => {
			if (!script) return;
			delete IDS[callback];
			delete CACHE[url];
			clearTimeout(timer);
			window[callback] = null;
			try { delete window[callback]; }
			catch (e) {}
			script.parentNode.removeChild(script);
			script = null;
			(data instanceof Error ? reject : resolve)(data);
		};
		let timer = setTimeout( () => done(Error('Timed out')), (options.timeout || 30)*1000);
		let script = document.createElement('script');
		script.async = true;
		script.src = url + (~url.indexOf('?')?'&':'?') + (options.callbackParam || 'callback') + '=' + callback;
		(document.head || document.body).appendChild(script);
	});
}



// WEBPACK FOOTER //
// ../node_modules/@cube/framework-service/src/fetch-jsonp.js